import FalconComponentCard from "components/common/FalconComponentCard";
import { useCallback, useEffect, useState } from "react";
import { Button, Col, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { MdAdd } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import RolesListTable from "./component/RolesListTable";
import { GetAllRoleList } from "./config/RoleApi";
import paths from "routes/paths";
const SystemPrivillageMain = () => {
  const dispatch = useDispatch();
  const { roleListData } = useSelector((state) => state.roleAdmin);
  const navigate = useNavigate();

  const { control, watch, handleSubmit, setValue, reset } = useForm();
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const requestBody = (customPage = page, customLimit = rowsPerPage) => ({
    start_point: customPage,
    limit: customLimit,
  });

  const handlePageChange = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  const handlePerRowsChange = useCallback((newPerPage) => {
    setRowsPerPage(newPerPage);
    setPage(0); // Reset to first page when changing page size
  }, []);
  const fetchRoleList = async (body = {}) => {
    try {
      const response = await dispatch(GetAllRoleList(body)).unwrap();
      setTotalRows(response?.total_rows || 0);
    } catch (error) {
      toast.error("Something Went Wrong");
    }
  };
  useEffect(() => {
    const body = requestBody(page, rowsPerPage);
    fetchRoleList(body);
  }, [page, rowsPerPage]);
  const handleCheckListFilter = () => {
    const newPage = 0;
    setPage(newPage); // Reset page
    const body = requestBody(newPage, rowsPerPage);
    fetchBranchList(body);
  };
  return (
    <Form
      noValidate
      onSubmit={handleSubmit(handleCheckListFilter)}
      className="p-0"
    >
      <FalconComponentCard
        className="shadow-md"
        style={{ position: "relative" }}
      >
        <FalconComponentCard.Header
          className="d-flex  fixed-header justify-content-between align-items-center"
          sx={{
            position: "sticky !important",
            top: 68,
            zIndex: 1020,
            backgroundColor: "white",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <Col xs="auto m-0">
            <h5 className="text-primary mb-0 fs-10">Roles List</h5>
          </Col>

          <Button
            size="sm"
            variant="secondary"
            onClick={() => navigate(`${paths.systemPrivillage}/add`)}
          >
            <MdAdd />
            New
          </Button>
        </FalconComponentCard.Header>
        <FalconComponentCard.Body
          style={{
            marginTop: "40px", // Adjust this value based on header height
            overflowY: "auto",
            maxHeight: "calc(100vh - 200px)", // Adjust based on your needs
          }}
        >
          <RolesListTable
            data={roleListData}
            totalRows={totalRows}
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange}
            page={page}
            rowsPerPage={rowsPerPage}
          />
        </FalconComponentCard.Body>
      </FalconComponentCard>
    </Form>
  );
};

export default SystemPrivillageMain;
